import { useNotification } from "components/Notification/useAddNotification";

export const useResetPasswordNotification = () => {
  const { addNotification } = useNotification();
  const notificationTitle = "Reset hasła";

  const showSuccessNotification = () =>
    addNotification({
      title: notificationTitle,
      description: "Pomyślnie zresetowano hasło.",
      type: "success",
    });

  const showErrorNotification = (errorMessage?: string) =>
    addNotification({
      title: notificationTitle,
      description: errorMessage ?? "Resetowanie hasła nie powiodło się.",
      type: "error",
    });

  return { showSuccessNotification, showErrorNotification };
};
